<div class="map-controls-container">
  <!-- Layers toggle button (opens tabbed popup) -->
  <div class="basemap-toggle-wrapper">
    <!-- Tooltip -->
    <div class="basemap-tooltip"
      [class.visible]="showTooltip && !showPopup"
      [class.fade-out]="fadeOutTooltip">
      {{ projectLayersInSidenav ? 'Basemap' : 'Layers' }}
    </div>

    <button #layersToggleButton
      class="control-button basemap-toggle"
      [class.satellite]="currentBasemap === 'satellite' || currentBasemap === 'imagery'"
      [class.active]="showPopup"
      [style.background-image]="(currentBasemap === 'satellite' || currentBasemap === 'imagery') && mapScreenshotUrl ? 'url(' + mapScreenshotUrl + ')' : 'none'"
      (click)="togglePopup()"
      (mouseenter)="onMouseEnter()"
      (mouseleave)="onMouseLeave()"
      [attr.aria-expanded]="showPopup"
      aria-haspopup="dialog"
      [attr.aria-label]="projectLayersInSidenav ? 'Basemap' : 'Layers: project layers and basemap'"
      data-testid="map-layers-button">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14 3.27459L25.5494 10.3834L14 17.416L2.45059 10.3834L14 3.27459Z" stroke="#060B1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.5 15.0488L14.0024 21.4531L24.5048 15.0488" stroke="#060B1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M3.5 19.3379L14.0024 25.7793L24.5048 19.3379" stroke="#060B1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
    @if (!projectLayersInSidenav && projectLayers.visibleOverlayIds.length) {
      <span class="project-layer-count" aria-hidden="true">{{ projectLayers.visibleOverlayIds.length }}</span>
    }
  </div>

  <!-- Zoom in button -->
  <button class="control-button"
    (click)="onZoomIn()"
    aria-label="Zoom in">
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.66675 13.9989H23.3334" stroke="#060B1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M14.0001 23.3327V4.66602" stroke="#060B1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <!-- Zoom out button -->
  <button class="control-button"
    (click)="onZoomOut()"
    aria-label="Zoom out">
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.66675 14.0009H23.3334" stroke="#060B1E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
</div>

<!-- One layers entry point; project context and basemap keep separate controls. -->
@if (showPopup) {
  <div #layersPopup
    class="layers-popup project-layers-popup"
    role="dialog" [attr.aria-label]="projectLayersInSidenav ? 'Basemap' : 'Map layers'" data-testid="map-layers-panel">
    <div class="layers-panel-header">
      <span class="mat-subtitle-1">{{ projectLayersInSidenav ? 'Basemap' : 'Layers' }}</span>
      <button type="button" class="layers-icon-action" (click)="closeLayers()" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    @if (projectLayersInSidenav) {
      <!-- Design layers live in the View panel's Design tab; this control is the basemap only. -->
      <ng-container *ngTemplateOutlet="basemapList"></ng-container>
    } @else {
    <mat-tab-group animationDuration="0ms" [dynamicHeight]="true">
    <mat-tab label="Project layers">
    <div class="layers-section-heading">
      <span></span>
      @if (canManageLayers) {
        <button type="button" class="layers-text-action" (click)="addProjectLayer.emit(); closeLayers()">Add layer</button>
      }
    </div>
    @if (projectLayers.overlayLoading) {
      <p class="layers-state" role="status">Loading project layers…</p>
    } @else if (projectLayers.overlayError) {
      <div class="layers-state" role="alert">
        <p>{{ projectLayers.overlayError }}</p>
        <button type="button" class="layers-text-action" (click)="projectLayersRetry.emit()">Try again</button>
      </div>
    } @else if (!projectLayers.overlayLayers.length) {
      <p class="layers-state">No project layers configured.</p>
    } @else {
      <label class="layers-search">
        <mat-icon aria-hidden="true">search</mat-icon>
        <input type="search" placeholder="Search layers" aria-label="Search project layers"
          [value]="layerSearch" (input)="setLayerSearch($event)" data-testid="map-layers-search" />
      </label>
      <div class="project-layers-list">
        @for (group of filteredProjectLayerGroups; track group.name) {
          <section class="project-layer-group">
            @if (group.name !== 'Project layers' || hasPublishedGroups) {
              <h4 class="project-layer-group-name">{{ group.name }}</h4>
            }
            @for (entry of group.entries; track entry.id) {
              <div class="project-layer-item" [attr.data-layer-id]="entry.id">
            <div class="project-layer-heading">
              <label class="project-layer-toggle">
                <input type="checkbox" [checked]="projectLayers.visibleOverlayIds.includes(entry.id)"
                  (change)="projectLayerToggle.emit(entry.id)" [attr.aria-label]="'Show ' + entry.name" />
                <span class="project-layer-name">{{ entry.name }}@if (entry.sourceLabel) {<small>{{ entry.sourceLabel }}</small>}</span>
              </label>
              @if (entry.extent) {
                <button type="button" class="layers-icon-action" (click)="projectLayerZoom.emit(entry.id)"
                  [attr.aria-label]="'Zoom to ' + entry.name" [title]="'Zoom to ' + entry.name">
                  <mat-icon>zoom_in_map</mat-icon>
                </button>
              }
            </div>
            @if (projectLayers.visibleOverlayIds.includes(entry.id)) {
              <label class="project-layer-opacity">
                <span>Opacity <output>{{ opacityPercent(entry.opacity) }}%</output></span>
                <input type="range" min="0" max="100" step="1" [value]="opacityPercent(entry.opacity)"
                  (input)="changeLayerOpacity(entry.id, $event)" [attr.aria-label]="entry.name + ' opacity'" />
              </label>
              @if (entry.labels !== undefined) {
                <label class="layers-swipe-toggle"><input type="checkbox" [checked]="entry.labels"
                  (change)="projectLayerLabels.emit(entry.id)" /> Labels</label>
              }
              @if (entry.status === 'loading') { <p class="layer-load-status" role="status">Loading layer…</p> }
              @if (entry.error) { <p class="layer-load-status" role="alert">{{ entry.error }}</p> }
            }
              </div>
            }
          </section>
        } @empty { <p class="layers-state">No layers match your search.</p> }
      </div>
      <div class="layers-view-actions">
        <button type="button" class="layers-text-action" (click)="projectLayersReset.emit()">Reset to project defaults</button>
        @if (!contained) {
        <button type="button" mat-stroked-button class="layers-compare-action"
          [disabled]="!projectLayers.visibleOverlayIds.length"
          [attr.aria-pressed]="projectLayers.swipePreset === 'project-design-vs-asbuilt'"
          (click)="projectLayerSwipe.emit(projectLayers.swipePreset === 'project-design-vs-asbuilt' ? 'off' : 'project-design-vs-asbuilt')">
          <mat-icon aria-hidden="true">compare</mat-icon>
          {{ projectLayers.swipePreset === 'project-design-vs-asbuilt' ? 'Stop comparison' : 'Swipe to compare' }}
        </button>
        @if (projectLayers.swipePreset === 'project-design-vs-asbuilt') {
          <p class="layers-personal-note">Drag the divider to compare project layers with SiteNotes records.</p>
        }
        }
      </div>
    }
    <p class="layers-personal-note">Layer visibility and opacity apply only to your view.</p>
    </mat-tab>
    <mat-tab label="Basemap">
      <ng-container *ngTemplateOutlet="basemapList"></ng-container>
    </mat-tab>
    </mat-tab-group>
    }
  </div>
}

<ng-template #basemapList>
    <div class="basemap-list"
      role="radiogroup" aria-label="Basemap"
      [attr.data-basemap-count]="sortedBasemaps.length <= 3 ? sortedBasemaps.length : 'many'">
      @for (basemap of sortedBasemaps; track basemap; let i = $index) {
        <button type="button" class="basemap-item" role="radio" [attr.aria-label]="basemap.title" [attr.aria-checked]="currentBasemap === basemap.id"
          (click)="selectBasemap(basemap.id)">
          <div class="basemap-thumbnail">
            <img [src]="getBasemapThumbnail(basemap.id)" [alt]="basemap.title" />
            <div class="radio-overlay" [class.selected]="currentBasemap === basemap.id">
              @if (currentBasemap === basemap.id) {
                <div class="radio-inner"></div>
              }
            </div>
          </div>
          <span class="basemap-text"
            [class.selected]="currentBasemap === basemap.id"
          [title]="basemap.title">{{ basemap.title }}</span>
        </button>
      }
    </div>
</ng-template>
